import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/shared/services/config-service';
import { Session } from '../models/session';
import { UserStore } from 'src/app/shared/user/store/user.store';

@Injectable({
  providedIn: 'root'
})
export class NectaSessionService {

  private http = inject(HttpClient);
  private configService = inject(ConfigService);
  private userStore = inject(UserStore);

      public createNectaSession(session: Session): Observable<Session> {
       return this.http.post<Session>(`${this.configService.getUrlNectaOneApi()}/${this.userStore.activeTenant()?.tenantId}/login`,session, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      });
   }
}
